export interface ApiError {
  response?: {
    data?: {
      message?: string
      errors?: string[] | Record<string, string[]>
      title?: string
    }
  }
}

export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error && typeof error === 'object' && 'response' in error) {
    const apiError = error as ApiError
    const data = apiError.response?.data
    
    if (data?.errors) {
      // Handle array format: { errors: ["error1", "error2"] }
      if (Array.isArray(data.errors)) {
        return data.errors.join('. ')
      }
      
      // Handle object format: { errors: { "Password": ["error1"], "Email": ["error2"] } }
      if (typeof data.errors === 'object') {
        const allErrors: string[] = []
        Object.values(data.errors).forEach(errorArray => {
          if (Array.isArray(errorArray)) {
            allErrors.push(...errorArray)
          }
        })
        if (allErrors.length > 0) {
          return allErrors.join('. ')
        }
      }
    }
    
    return data?.message || data?.title || fallback
  }
  if (error instanceof Error) {
    return error.message
  }
  return fallback
}